/* eslint-env es6 */
/* eslint-disable no-restricted-syntax */

(() => {
	if (typeof IntersectionObserver === "undefined") {
		return;
	}

	/** Between [0, 200] ms */
	const animationDelay = 200;
	/** Between [200, 400] ms */
	const animationDuration = 400;
	/** Any element matching this selector will animate :) */
	const upCounterElems = document.querySelectorAll(".js-count_up");
	/** The integer to start the count from */
	const startingNumber = 1;

	for (const upCounter of upCounterElems) {
		const count = parseInt(upCounter.textContent, 10);
		if (!count || count <= startingNumber) {
			continue;
		}
		let isRunning;
		// IntersectionObserver detects when the element is visible in the viewport
		const observer = new IntersectionObserver(
			() => {
				if (isRunning) {
					return;
				}
				isRunning = animateUp(upCounter, count, () => (isRunning = 0));
			},
			{threshold: 1.0} // 100% visible
		);

		observer.observe(upCounter);
	}

	/**
	 * Counts a number from 0 to `count`, updating the `counter` element periodically.
	 * @param {HTMLElement} counterElem
	 * @param {number} targetCount A positive, non-zero integer
	 * @param {function} callback Executes when the animation finishes
	 */
	function animateUp(counterElem, targetCount, callback) {
		let count = startingNumber;
		counterElem.textContent = count;

		return setTimeout(() => {
			const interval = setInterval(() => {
				counterElem.textContent = ++count;

				if (count === targetCount) {
					clearInterval(interval);
					callback();
				}
			}, animationDuration / targetCount);
		}, animationDelay);
	}
})();
